import React, { useState, useEffect } from 'react';
import { KFLDialog } from '@kamstrup/kamstrup-frontend-library';
import { connect } from 'react-redux';
import Translate from '../shared/localization/localize';
import DialogHeader from '../shared/dialog/dialogHeader';
import { ReduxState } from '../../interfaces';
import DeviceInfoItemDetails from './deviceInfoDetails';
import DeviceInfoItemStatus from './deviceInfoStatus';
import NavLinkBtn from '../shared/navLinkBtn';
import * as DeviceInfo from '../../modules/dialogs/deviceInfo';
import * as Devices from '../../modules/devices';
import DialogSection from '../shared/dialog/dialogSection';
import useDialog from '../shared/dialog/useDialog';

interface StateProps extends DeviceInfo.State {
  devicesData: Devices.Data;
}

type Props = StateProps;

const DeviceInfoDialog: React.FC<Props> = (props: Props) => {
  const {setDialog} = useDialog();
  const [item, setItem] = useState(undefined as DeviceInfo.Item | undefined);

  useEffect(() => {
    setItem(
      DeviceInfo.getItem(props.deviceKey, props.items, props.devicesData)
    );
  }, [props.deviceKey, props.items, props.devicesData]);

  if (!item) return <></>;

  const isLoading = item.getInfoCall.isFetching;
  const sections = (
    <>
      <DialogSection scrollable>
        <DeviceInfoItemDetails
          key="dialog-deviceinfo-details"
          item={item}
          isLoading={isLoading}
        />
      </DialogSection>
      <DialogSection scrollable>
        <DeviceInfoItemStatus key="dialog-deviceinfo-status" item={item} />
      </DialogSection>
      <DialogSection isMain>
        <NavLinkBtn onClick={DeviceInfo.openLogsDialog}>
          <Translate message={DeviceInfo.msgLogsLink} />
        </NavLinkBtn>
      </DialogSection>
    </>
  );

  return (
    <KFLDialog
      header={
        <DialogHeader
          title={<Translate message={DeviceInfo.msgHeader} />}
          fnCloseDialog={() => setDialog?.()}
        />
      }
      sections={[sections]}
    />
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  ...state.dialogState.deviceInfoDialog,
  devicesData: state.devicesState.data,
});

export default connect(mapStateToProps)(DeviceInfoDialog);
